<template>
    <v-container fill-height class="d-flex align-center justify-center">
        <v-row justify="center" align="center" class="w-100">
            <home-card
                v-if="this.me.role.permissions.includes('ADMIN_COMPANY_SHOW')"
                :title="$t('admin.company.title')"
                :subtitle="$t('admin.company.subtitle')"
                :img="require('@/assets/cards/company-management.png')"
                :link="{ name: 'CompanyManagementPage' }"
            ></home-card>
            <home-card
                v-if="this.me.role.permissions.includes('ADMIN_USER_SHOW')"
                :title="$t('admin.inviraUser.title')"
                :subtitle="$t('admin.inviraUser.subtitle')"
                :img="require('@/assets/cards/user-management.png')"
                :link="{ name: 'InviraUserManagementPage' }"
            ></home-card>
            <home-card
                v-if="this.me.role.permissions.includes('ADMIN_Invira_ROLE_SHOW')"
                :title="$t('admin.inviraRole.title')"
                :subtitle="$t('admin.inviraRole.subtitle')"
                :img="require('@/assets/cards/role-management.png')"
                :link="{ name: 'InviraRolesManagementPage' }"
            ></home-card>
        </v-row>
    </v-container>
</template>

<script>
    import HomeCard from './HomeCard'
    import {mapGetters} from "vuex";
    export default {
        name: 'HomePage',
        components: {
            HomeCard
        },
        mounted() {
            this.$store.dispatch('checkAuth')
        },
        computed: {
            ...mapGetters(['me']),
            getUserId() {
                return this.me ? this.me.id : null
            }
        }
    }
</script>

